<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">
      <i class="fa fa-bell" aria-hidden="true"></i>&nbsp;
      <a *ngIf="isNewAds">{{ "TITLE.ADD-ADS" | translate }}</a>
      <a *ngIf="!isNewAds">{{ "TITLE.EDIT-ADS" | translate }}</a>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="adsForm">
      <div class="form-group">
        <label class="font-weight-bold" for="adsInput">{{ "LABEL.TYPE" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i class="{{adsType === 1 ? 'fa fa-file-image': 'fas fa-text-width'}}" aria-hidden="true"></i>
            </div>
          </div>
          <select id="adsInput"
                  class="form-control"
                  [(ngModel)]="adsType"
                  (change)="change(adsType)"
                  formControlName="type">
            <option *ngFor="let adsType of adsTypes"
                    [ngValue]="adsType.id">
              {{adsType.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label class="font-weight-bold">{{ "LABEL.DESCRIPTION" | translate }}</label>
        <quill-editor [styles]="{height: '200px'}"
                      [(ngModel)]="ads.description"
                      formControlName="description">
        </quill-editor>
      </div>
      <div formArrayName="arrayImage" [hidden]="isTextType(adsType)">
        <div class="form-row" *ngFor="let group of arrayImage.controls; let index= index" [formGroupName]="index">
          <div class="col-md-8">
            <div class="padding-select-file">
              <div class="custom-file content-file">
                <input type="file" class="custom-file-input w-100 content-file" accept="image/*"
                       id="customFile{{index}}" (change)="changeStatus($event, index)"
                       [class.is-invalid]="isInvalidControl('file', index)">
                <label class="custom-file-label"
                       for="customFile{{index}}">
                  {{group.get('filename').value ? group.get('filename').value : "MESSAGE.SELECT" | translate }}
                </label>
              </div>
              <small class="text-danger"
                     *ngIf="isInvalidControl('file', index)">{{ "MESSAGE.SELECT-FILE" | translate }}</small>
            </div>
          </div>
          <div class="col-md-3">
            <div class="progress form-group mt-2">
              <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
                   [style.width.%]="progressUpdate">
              </div>
            </div>
          </div>
          <div class="col-md-1">
            <i class="fa fa-times mt-2"
               *ngIf="arrayImage.controls.length > 1"
               (click)="deleteRow(index)"></i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label for="link" class="col-form-label mb-6">{{ "LABEL.LINK" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-link" aria-hidden="true"></i></div>
            </div>
            <input id="link" class="form-control custom-input" formControlName="link" [(ngModel)]="ads.link"
                   placeholder="https://example.com">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col" *ngIf="!isNewAds">
          <label for="showAds" class="col-form-label"> {{ "LABEL.SHOW-ADS" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="{{isActive ? 'input-group-text': 'input-group-text-danger' }}"><i
                class="{{isActive ? 'fas fa-toggle-on': 'fas fa-toggle-off' }}"></i></div>
            </div>
            <select class="form-control"
                    id="showAds"
                    formControlName="showAds"
                    [(ngModel)]="ads.showAds">
              <option [value]="true">{{ "BUTTON.YES" | translate }}</option>
              <option [value]="false">{{ "BUTTON.NO" | translate }}</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger"
            (click)="cancel()" data-dismiss="alert" aria-label="Close">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>

